declare const APP_ENV: string;

export const sanitizeUrl = (url: string) => {
  try {
    const parsedUrl = new URL(url);
    if (parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:') {
      return url;
    }
  } catch {
    // Invalid URL format
  }
  return 'about:blank';
};

export const containsPaymentLink = (text: string) => {
  const isProd = APP_ENV === 'PROD';
  const paymentDomain = isProd ? 'dazzle.ai/payment' : 'dazzleassist.com/payment';
  return text.includes(paymentDomain);
};
